import { createRoute, useNavigate } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { ExpensesPage } from "@/components/expenses/expenses-page";
import { Route as authenticatedRoute } from "../_authenticated";

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/expenses",
  component: ExpensesPageGuard,
});

function ExpensesPageGuard() {
  const { data: session } = useSession();
  const navigate = useNavigate();

  // biome-ignore lint/suspicious/noExplicitAny: session user type lacks role
  if ((session?.user as any)?.role !== "admin") {
    navigate({ to: "/my-dashboard" });
    return null;
  }

  return <ExpensesPage />;
}
